import { createReducer, createAction } from '@reduxjs/toolkit';

import type { RootState } from '@store/types';
import type { GlobalAddState } from './types';

// Re-export types for consumers
export type { GlobalAddState } from './types';

// === Initial State ===

const initState: GlobalAddState = { globalSelectedLevel: null, globalImageContext: null };

// === Selectors ===

export const selectGlobalSelectedLevel = (state: RootState) => state.globalAdd.globalSelectedLevel;
export const selectGlobalImageContext = (state: RootState) => state.globalAdd.globalImageContext;

// === Actions ===

export const clear = createAction('clear');
export const close = createAction('globalAdd/close');
export const setGlobalSelectedLevel = createAction<GlobalAddState['globalSelectedLevel']>('globalAdd/setGlobalSelectedLevel');
export const setGlobalImageContext = createAction<GlobalAddState['globalImageContext']>('globalAdd/setGlobalImageContext');

// === Reducer ===

export default createReducer<GlobalAddState>(JSON.parse(JSON.stringify(initState)), (builder) => {
  builder
    .addCase(setGlobalSelectedLevel, (state, action) => ({
      ...state,
      globalSelectedLevel: action.payload,
    }))
    .addCase(setGlobalImageContext, (state, action) => ({
      ...state,
      globalImageContext: action.payload,
    }))
    .addCase(clear, () => {
      return initState;
    })
    .addCase(close, () => {
      return initState;
    });
});
